/** Star rating value — whole numbers from 1 to 5 */
export type StarRatingValue = 1 | 2 | 3 | 4 | 5

/** Rating dimensions for the new star rating system (SERVICE removed) */
export enum StarRatingDimension {
  VISUALS = 'VISUALS',
  CREATIVE = 'CREATIVE',
}

/** Criteria checkboxes shown when rating is below 5 stars */
export enum StarRatingCriterion {
  LOW_PROFESSIONALISM = 'LOW_PROFESSIONALISM',
  COMMUNICATION_ISSUES = 'COMMUNICATION_ISSUES',
  ARRIVED_LATE = 'ARRIVED_LATE',
  INSTRUCTIONS_NOT_FOLLOWED = 'INSTRUCTIONS_NOT_FOLLOWED',
}
